import { render, staticRenderFns } from "./TaxTable.vue?vue&type=template&id=f718a98a&scoped=true"
import script from "./TaxTable.vue?vue&type=script&lang=ts"
export * from "./TaxTable.vue?vue&type=script&lang=ts"
import style0 from "./TaxTable.vue?vue&type=style&index=0&id=f718a98a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f718a98a",
  null
  
)

export default component.exports